// 全局通用
import img from './mm/img.vue'
import dialog from './mm/dialog.vue'
import skeleton from './mm/skeleton.vue'
import auth from './mm/auth.vue'

export default function (app) {
  app.component('MmImg', img)
  app.component('MmDialog', dialog)
  app.component('MmSkeleton', skeleton)
  app.component('MmAuth', auth)
}
